<template>
    <Link class="card card-body mb-3" :class="customClass" :href="href">
        {{ title }}
    </Link>
</template>

<script setup lang="ts">
import {Link} from "@inertiajs/vue3";

const {title, href, customClass} = defineProps<{
    title: string,
    href: string,
    customClass?: string[]
}>()
</script>

<style scoped lang="scss">
.card-body {
    text-decoration: none;
    text-align: center;
    font-size: calc(0.4rem + 1vw);
    background-color: var(--bs-black);
    color: var(--bs-white);
    border-color: var(--bs-black);
    transition: all 150ms linear;
    padding: 2rem 1rem;
    white-space: nowrap;

    &:hover, &:active {
        background-color: var(--bs-orange-custom);
        border-color: var(--bs-orange-custom);
    }
}
</style>
